import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const PcrEmergencyNotificationPage = lazy(
  () =>
    import('@/pages/emergency-notifications/ui/PcrEmergencyNotificationPage'),
)

/** The ПЦР study the извещение is raised from — its id is the only link back. */
interface Search {
  pcrStudyId: string
}

export const Route = createFileRoute(
  '/_protected/laboratory/notifications/new',
)({
  validateSearch: (search: Record<string, unknown>): Search => ({
    pcrStudyId: String(search.pcrStudyId ?? ''),
  }),
  component: () => (
    <Suspense fallback={<Loader />}>
      <PcrEmergencyNotificationPage />
    </Suspense>
  ),
})
